import * as types from "../action/ActionType";
import type { AppAction } from "../action/ActionType";

export default function Requiredinvoicelineitem(
  state: unknown[] = [],
  action: AppAction
): unknown[] {
  switch (action.type) {
    case types.REQUIRED_INVOICE_LINE_ITEM:
      return action.payload;
    default:
      return state;
  }
}
